<template>
  <v-layout align-center justify-center fill-height class="green lighten-4">
    <v-card class="elevation-10" width="100%" :max-width="getMinWidth()">
      <v-toolbar color="primary" flat>
        <v-img src="@/assets/logo_simple.png" max-width="40"></v-img>
        <v-toolbar-title class="ml-3 white--text">
          Portal do Colaborador
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-chip v-if="isDevelopment()" class="mb-4" color="warning"
          >Servidor Homologação</v-chip
        >
        <v-form ref="form" lazy-validation>
          <v-text-field
            v-model="usuario"
            label="Usuário"
            prepend-icon="mdi-account"
            type="text"
            :rules="usuarioRules"
            required
          ></v-text-field>
          <v-text-field
            v-model="senha"
            label="Senha"
            prepend-icon="mdi-lock"
            :type="exibirSenha ? 'text' : 'password'"
            :rules="senhaRules"
            required
            :append-icon="exibirSenha ? 'mdi-eye-off' : 'mdi-eye'"
            @click:append="exibirSenha = !exibirSenha"
            @keypress.enter="login()"
          ></v-text-field>
          <v-row>
            <v-col md="12">
              <v-btn
                color="primary"
                @click="login()"
                class="mt-3"
                rounded
                :loading="logando"
                width="125"
                >Entrar</v-btn
              ><sem-acesso />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import SemAcesso from "./SemAcesso.vue";
import axios from "axios";
import { mapMutations, mapState } from "vuex";
import md5 from "md5";

export default {
  components: { SemAcesso },
  computed: mapState("usuario", ["usuarioLogado"]),
  data: () => ({
    usuario: "",
    usuarioRules: [(v) => !!v || "Informe seu usuário"],
    senha: "",
    senhaRules: [(v) => !!v || "Informe sua senha"],
    logando: false,
    exibirSenha: false,
  }),
  methods: {
    ...mapMutations("usuario", ["setUsuarioLogado"]),
    async login() {
      if (this.$refs.form.validate()) {
        this.logando = true;
        const user = this.usuario;
        const typeSystem = "FUNCIONARIO";

        const response = await axios.get(
          `/base/hash-password?usuario=${user}&sistema=${typeSystem}`,
          {
            headers: {
              "Cache-Control": "no-store",
              Pragma: "no-cache",
            },
          }
        );

        let pass = this.senha;

        if (response.data.success) {
          if (response.data.data.hash_password) {
            pass = md5(this.senha);
          }

          try {
            const loginResponse = await axios.post(
              "/colaborador/login",
              JSON.stringify({
                usuario: this.usuario,
                senha: pass,
                sistema: typeSystem,
              })
            );

            if (loginResponse.data.success) {
              sessionStorage.setItem("userKey", loginResponse.data.data.token);
              this.$router.push("/");
            } else {
              this.$toasted.error(loginResponse.data.msg);
            }
          } catch (error) {
            this.$toasted.error(
              `Ocorreu um erro ao fazer o login no sistema. ${error}`
            );
          } finally {
            this.logando = false;
          }
        } else {
          this.$toasted.error(response.data.msg);
          this.logando = false;
        }
      }
    },
    isDevelopment() {
      return process.env.NODE_ENV === "development";
    },
    getMinWidth() {
      return this.$mq == "sm" ? 300 : 380;
    },
  },
};
</script>

<style>
.v-toolbar__title {
  font-size: 1.1rem !important;
}
</style>
